import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TimezoneInitialStateInterface, TimezoneListI } from './types';
import fetchTimezone from './fetchTimezone';

export const initialState: TimezoneInitialStateInterface = {
  loading: false,
  error: false,
  list: [],
};

export default createSlice({
  name: 'timezone',
  initialState,
  reducers: {
    setLoader: (state, action): void => {
      state.loading = true;
    },
    setError: (state, action): void => {
      state.error = true;
    },
  },
  extraReducers: {
    [fetchTimezone.fulfilled.type]: (
      state,
      action: PayloadAction<TimezoneListI[]>
    ): void => {
      state.loading = false;
      state.list = action.payload;
    },
  },
});
